import err from '../images/error404.png'
import styled from 'styled-components'

const Div = styled.div`
  display: flex;
  justify-content: center;
`
const Error404 = styled.img`
  position: absolute;
  top: 20;
  width: 90%;
  height: 90%;
  border-radius: 10%;
`

function Error() {
  return (
    <Div>
      <Error404 src={err} alt="error404"></Error404>
    </Div>
  )
}

export default Error
